<div class="main-container">
  <div class="container-title">
    <div class="left-bar"></div>
    <sit-icon [icon]="icon.alert" format="svg" class="" colorClass="icon-fill-white" />
    <h2 class="title">Alertas</h2>
  </div>
  <div class="container-cards">
    <cdk-virtual-scroll-viewport itemSize="200" class="cards-viewport custom-scrollbar">
      <div class="cards" *cdkVirtualFor="let card of filteredCards" >
        <div class="header">
          <span class="text text-color-primary-1"> {{card.id}} </span>
          <span class="text "> {{ formatText(card.establishment) }}</span>
        </div>
        <div class="content" (click)="openModal(card)">
          <div class="content-header">
            <span class="text"  mat-raised-button #tooltip="matTooltip" matTooltip="Dirección" matTooltipPosition="above"> <sit-icon [icon]="icon.location_w" format="svg" class="icon-size-24"
                colorClass="icon-fill-white" />
              {{formatText(card.address)}}
            </span>
          </div>
          <div class="content-body">
            <span class="text" mat-raised-button #tooltip="matTooltip" matTooltip="Fecha de creación" matTooltipPosition="above">
              <sit-icon [icon]="icon.calendar_w" format="svg" class="icon-size-24" colorClass="icon-fill-white" />
              {{ splitDateTime(card.creationDate).date }}
            </span>
            <span class="text"  mat-raised-button #tooltip="matTooltip" matTooltip="Hora de creación" matTooltipPosition="above"> <mat-icon>schedule</mat-icon>{{ splitDateTime(card.creationDate).time }}</span>
            <span class="text"  mat-raised-button #tooltip="matTooltip" matTooltip="Identificador del dispositivo" matTooltipPosition="above"> <mat-icon>perm_device_information</mat-icon> {{ formatText(card.deviceId)}}</span>
            <span class="text"  mat-raised-button #tooltip="matTooltip" matTooltip="Número de teléfono" matTooltipPosition="above"> <mat-icon> phone</mat-icon> {{card.phone}}</span>
          </div>
        </div>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</div>
